import _trimStart from 'lodash/trimStart';

export const cdnSrc = src => (/^https?:/.test(src) ? src : `${process.env.VUE_APP_AWS_BASEURL}/${_trimStart(src, '/')}`);

export const cdnMemberSrc = src => `${process.env.VUE_APP_AWS_MEMBERSHIP_URL}/${_trimStart(src, '/')}`;
